import { useCallback } from 'react';
import { useEditBoardSettingsPanelContext } from 'crm-pipeline-board-settings-lib/EditBoardSettingsPanel';
export const useGetCurrencyFormatting = () => {
  const {
    settings: cardPreferences
  } = useEditBoardSettingsPanelContext();
  const isCurrencyAbbreviated = cardPreferences.currencyFormatPreferences.isAbbreviated;
  return useCallback(value => {
    const abbreviate = Number(value) >= 1000000;
    return isCurrencyAbbreviated ? {
      simplifyCurrency: true,
      abbreviate,
      // For values less than 1000000 (non-abbreviated) we want to have no decimal places
      // For values greater than 1000000 (abbreviated) we want to have at most one decimal place
      precision: abbreviate ? 1 : 0,
      maxFractionDigits: 1
    } : {};
  }, [isCurrencyAbbreviated]);
};